import { jsx as _jsx } from "react/jsx-runtime";
import { FormSourceWalletButton } from "../../../../../components/Input/SourceWalletPicker";
import SubmitButton from "../../../../../components/Buttons/submitButton";
import { useInitialSettings } from "../../../../../context/settings";
import Address from "../../../../../components/Input/Address";
const FormButton = ({ shouldConnectWallet, values, disabled, error, isSubmitting, isQuoteLoading, partner, }) => {
    const initialSettings = useInitialSettings();
    const actionDisplayName = error || initialSettings?.actionButtonText || "Next";
    const preSubmitDisabled = isSubmitting || isQuoteLoading;
    const button = (() => {
        if (shouldConnectWallet && (!error || !values.to || !values.amount)) {
            return _jsx(FormSourceWalletButton, { isDisabled: preSubmitDisabled });
        }
        if (values?.to && !values?.destination_address && !error) {
            return (_jsx(Address, { partner: partner, children: () => (_jsx(SubmitButton, { type: "button", className: "w-full", isDisabled: preSubmitDisabled, children: _jsx("span", { className: "grow text-center", children: "Enter destination address" }) })) }));
        }
        return (_jsx(SubmitButton, { "data-attr": "submit-swap", type: "submit", isDisabled: disabled, isSubmitting: isSubmitting, children: actionDisplayName }));
    })();
    return (_jsx("div", { className: "flex flex-col gap-2 w-full", children: button }));
};
export default FormButton;
